export default "__VITE_ASSET__BA2VQSTK__"